export const PAGINATION_ROWS_PER_PAGE_OPTIONS = [15, 25, 50];
export const PAGINATION_DEFAULT_ROWS_PER_PAGE = 15;
